import { defineComponent as _defineComponent } from 'vue'
import type { RefDataItem as Item } from '@/foundations/helpers/refDataFilters';

type Props = {
  items: Item[];
  itemText: string;
  colorOf?: (item: Item) => string | undefined;
};
type Emits = {
  (e: 'select', id: string): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestionChips',
  props: {
    items: null,
    itemText: null,
    colorOf: null
  },
  emits: ["select"],
  setup(__props: any) {

const props = __props as {
  items: Item[];
  itemText: string;
  colorOf?: (item: Item) => string | undefined;
}





const colorFor = (item: Item) => props.colorOf?.(item);

return { __sfc: true,props, colorFor }
}

})